import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, GenericSearchResponse, ImportUnidadFuncionalExcelRequestDto, ImportUnidadFuncionalPersonaExcelRequestDto, SaveUnidadFuncionalDto, SaveUnidadFuncionalPersona, SearchUnidadFuncionalRequest, UnidadFuncional, UnidadFuncionalRelacionesRequestDto } from "../model/index";
import { UploadUnidadFuncionalAttachResponseDto, UnidadFuncionalAdjunto, UnidadFuncionalGastosPorcentaje, SaveUnidadFuncionalPersonaRelacionDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class UnidadFuncionalService extends CrudService<UnidadFuncional, number, SaveUnidadFuncionalDto, SearchUnidadFuncionalRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'unidadfuncional', sharedFunctions);

  }

  getAttachments(id: number): Observable<GenericResponse<UnidadFuncionalAdjunto[]>> {
    return this._http.get<GenericResponse<UnidadFuncionalAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getTipoGastoPorcentajes(id: number): Observable<GenericResponse<UnidadFuncionalGastosPorcentaje[]>> {
    return this._http.get<GenericResponse<UnidadFuncionalGastosPorcentaje[]>>(this._serviceUrl + '/' + id + '/tipos-gasto-porcentajes', this.httpOptions);
  }

  getRelaciones(value: UnidadFuncionalRelacionesRequestDto): Observable<GenericResponse<any[]>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericResponse<any[]>>(this._serviceUrl + '/relaciones' + queryString, this.httpOptions);
  }

  searchTipoGastoPorcentajes(value: any): Observable<GenericSearchResponse<UnidadFuncionalGastosPorcentaje>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericSearchResponse<UnidadFuncionalGastosPorcentaje>>(this._serviceUrl + '/search-tipos-gasto-porcentajes' + queryString, this.httpOptions);
  }

  saveRelaciones(p: SaveUnidadFuncionalPersonaRelacionDto[]): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/save/relaciones', p, this.httpOptions);
  }

  sendNewUserInvitation(p: SaveUnidadFuncionalPersona): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/send-new-user-invitation', p, this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadUnidadFuncionalAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadUnidadFuncionalAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  downloadImportUfsTemplate(): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/download-import-ufs-template', this.httpCsvOptions);
  }

  downloadImportPropietariosTemplate(): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/download-import-propietarios-template', this.httpCsvOptions);
  }

  importFromExcel(value: ImportUnidadFuncionalExcelRequestDto): Observable<any> {
    return this._http.post<any>(this._serviceUrl + '/import', value, this.httpOptions);
  }

  importUfsPersonasFromExcel(value: ImportUnidadFuncionalPersonaExcelRequestDto): Observable<any>{
    return this._http.post<any>(this._serviceUrl + '/import-ufs-personas', value, this.httpOptions);
  }
}